import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=06d2f7ec"
import script from "./Sensors.vue?vue&type=script&lang=js"
export * from "./Sensors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports